import get from 'lodash/get';

const programTaxSystems = {
    vefa: 'Promotion VEFA',
    construction: 'Projet construction',
    ar: 'Ancien à rénover',
    vir: 'Vente d’immeuble à rénover',
};

const programStatus = {
    actable: 'Actable',
    unavailable: 'Indisponible',
    delivered: 'Livré',
};

function formatProgramTaxSystem(value: string[]) {
    const items = value.map(item => get(programTaxSystems, item, item));
    return items.join(', ');
}
function formatProgramStatus(value: string) {
    return get(programStatus, value, value);
}

export {
    programStatus,
    formatProgramTaxSystem,
    programTaxSystems,
    formatProgramStatus,
};
